import React, { useState, useEffect } from 'react';
import axios from '../api/api';
import { useParams } from 'react-router-dom';
import { toast } from  'react-toastify';
import Nav from './Nav'
import Footer from './Footer'
import { usePaystackPayment } from 'react-paystack';

const ViewTrailer = () => {
  const [trailer, setTrailer] = useState('');
  const [content, setContent] = useState('')
  const { id } = useParams();
  // const navigate = useNavigate()
  // current user details
  const user = window.localStorage.getItem('token');
  const currentUser = JSON.parse(user)?.data.email;

  useEffect(() => {
    const getTrailerById = async () => {
      try {
        const response = await axios.get(`/api/v3/stream/trailer/${id}`, { responseType: 'blob' });
        const videoBlob = new Blob([response.data], { type: 'video/mp4' });
        const url = URL.createObjectURL(videoBlob);
        setTrailer(url);
      } catch (error) {
        console.error('Error fetching trailer:', error.message);
        console.error(error);
      }
    };
    getTrailerById();
  }, [id]);

  useEffect(() => {
    const getTrailerDetails = async () => {
      try {
        const response = await axios.get(`/api/v3/contentdata/${id}`);
        setContent(response.data);
      } catch (error) {
        console.error('Error fetching video:', error.message);
        console.error(error);
      }
    };
    getTrailerDetails();
  }, [id]);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 4000));
      setIsLoading(false);
    };
    fetchData();
  }, []);

  // const revenue = content?.movieLock;
  // const percentage = content?.percentageAgreement;
  // console.log('percentage', percentage);
  // const [firstPartyPercentage, secondPartyPercentage] = percentage?.split('/').map(Number) || [0, 0];

  // // Calculate amounts based on the percentage agreement
  // const firstPartyAmount = (firstPartyPercentage / 100) * revenue;
  // const secondPartyAmount = (secondPartyPercentage / 100) * revenue;

  // console.log('First Party Amount', firstPartyAmount);
  // console.log(`Second Party Amount: ${secondPartyAmount}`);
  
  const config = {
    reference: (new Date()).getTime().toString(),
    email: currentUser,
    amount: content.movieLock,
    // split: [
    //   {
    //     account: '4084084084084081',
    //     percentage: 90, // Percentage share for the first account
    //   },
    //   {
    //     account: '507850785078507812',
    //     percentage: 10, // Percentage share for the second account
    //   },
    // ],
    publicKey: process.env.REACT_APP_RAVE_PUBLIC_KEY,
  };
  
  const initializePayment = usePaystackPayment(config);

  const handleClick = () => {
    try {
      // if (!currentUser) {
      //   // If not logged in, redirect to the login page
      //   navigate('/user-login');
      //   return;
      // }
      // initializePayment({
      //   onSuccess: (reference) => {
      //     // Implementation for whatever you want to do with reference and after success call.
      //     console.log(reference);
      //     navigate(`/viewer/viewvideo/${id}`);
      //     toast.success("You've successfully paid for the video! Enjoy watching it!");
      //   },
      //   onClose: () => {
      //     // Implementation for whatever you want to do when the Paystack dialog closed.
      //     console.log('closed');
      //     navigate(`/viewer/viewtrailer/${id}`);
      //     toast.error("Payment cancelled!");
      //   },
      // });
      // const productLink = content.videoProductLink
      window.location.href = 'https://paystack.com/pay/l6rciiucak';
    } catch (error) {
      console.error('Error during payment:', error);
      toast.error('Payment Failed');
    }
  };

  return (
    <div>
      <Nav/>
      <div className='mx-auto p-4 lg:container'>
        <div className='flex items-center justify-center'>
          <div className='px-4'>
            <div className='p-2'>
              <p>Home / Movies / Trailer</p>
            </div>
            <div>
              {isLoading
                ? (
                  <div>
                    <video width='1500' height='600' muted controls>
                      <source src={trailer} type='video/mp4' />
                    </video>
                  </div>
                  ) : (
                    <div className='w-full'>
                      {trailer.length > 0
                        ? (
                            <div className='flex flex-wrap'>
                              <div className='lg:w-3/4'>
                                <video width='1200' height='600' muted controls>
                                  <source src={trailer} type='video/mp4' />
                                  <source src='video.ogg' type='video/ogg' />
                                </video>
                              </div>
                              <div className='bg-slate-300 w-full lg:w-1/4 p-4'>
                                <p className='bg-blue-600 text-white p-4 font-bold'>Full Hd</p>
                              </div>
                            </div>
                          ) : (
                            <div className="relative">
                              <video width='1500' height='600' muted controls>
                                <source src={trailer} type='video/mp4' />
                              </video>
                              <h2 className='absolute inset-0 flex items-center justify-center text-red-600'>Trailer Loading....</h2>
                            </div>
                          )
                      }
                    </div>
                )
              }
            </div>
            <div className="flex flex-wrap p-4 mb-20 bg-white">
              <div>
                <img width={250} src={`https://naijaserver.cleverapps.io/api/v3/image/${content.coverPhoto}`} alt="" />
              </div>
              <div className='p-4 lg:w-1/2'>
                <h3>{content.movieName}</h3>
                <span>About: {content.movieSynopsis}</span>
                <div className='py-4 space-y-0.5'>
                  <p><b>Genre:</b> {content.movieType}</p>
                  <p><b>Actors:</b> {content.movieActors}</p>
                  <p><b>Director:</b> {content.movieProducer}</p>
                </div>
                <div className='space-y-2'>
                  <h4>Price : {content.movieLock} Naira</h4>
                  <button onClick={handleClick} className='bg-blue-600 text-white px-5 py-1 rounded-md hover:bg-blue-500'>Pay to watch full movie</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default ViewTrailer;
